import { render, staticRenderFns } from "./simpleKeyboard.vue?vue&type=template&id=2612842a&scoped=true&"
import script from "./simpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./simpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./simpleKeyboard.vue?vue&type=style&index=0&id=2612842a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2612842a",
  null
  
)

export default component.exports